import CRUDServiceOperations from "./CRUDServiceOperations";

class IndividualService extends CRUDServiceOperations {
  getEntitiesUrl = () => {
    return this.urlFactory.individualsUrl();
  };

  postEntity(entity, callback, failureCallback, successCallback = undefined) {
    const url = this.getEntitiesUrl();
    return this.post(
      url,
      entity,
      callback,
      successCallback,
      failureCallback,
      false
    );
  }
}

export default IndividualService;
